import NotificationsIcon from "@mui/icons-material/Notifications";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import {
  Badge,
  Box,
  Divider,
  Icon,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip
} from "@mui/material";
import React, { useContext, useState } from "react";

import { UserContext } from "../../../Context/UserContext";

/** The Notification bell navigation item and its popover. */
const Notifications: React.FC = () => {
  const { notifications, setNotifications } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const onClickIcon = (target: HTMLElement) => {
    setAnchorEl(target);
    setNotifications(notifs => notifs.map(n => ({ ...n, viewed: true })));
  };
  const onClickNotif = (index: number) =>
    setNotifications(n => {
      n.splice(index, 1);
      if (!n.length) setAnchorEl(undefined);
      return [...n];
    });
  const onClearNotifs = () => {
    setAnchorEl(undefined);
    // delay the clear so the hide animation doesn't jump around
    setTimeout(() => setNotifications([]), 300);
  };

  return (
    <>
      <Tooltip title="">
        <IconButton onClick={e => onClickIcon(e.currentTarget)} color="inherit" disabled={!notifications.length}>
          <Badge
            badgeContent={notifications.length}
            color={notifications.some(n => !n.viewed) ? "secondary" : "default"}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(undefined)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {[
          ...notifications.map((n, index) => (
            <MenuItem onClick={() => onClickNotif(index)} key={index} sx={{ minWidth: "22rem" }}>
              <ListItemIcon>
                <Icon color="primary">{n.icon}</Icon>
              </ListItemIcon>
              <ListItemText primary={n.message} />
            </MenuItem>
          )),
          <Divider key="divider" />,
          <MenuItem onClick={onClearNotifs} sx={{ minWidth: "22rem" }} key="final">
            <Box display="flex" justifyContent="center" width="100%">
              <ListItemIcon>
                <PlaylistAddCheckIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={notifications.length ? "Dismiss All" : "No Notifications"} />
            </Box>
          </MenuItem>
        ]}
      </Menu>
    </>
  );
};

export default Notifications;
